import { 
    PhoneAuthProvider,
    RecaptchaVerifier,
    signInWithPhoneNumber,
    ApplicationVerifier,
    signInWithCredential
} from 'firebase/auth';
import { auth } from '../firebase/config';

// Firebase Console'dan alınan reCAPTCHA site key'i
const RECAPTCHA_SITE_KEY = '6Le0NVgrAAAAAIoHOVtNyocfFJQRIMn27_hOF0BL';

// Telefon numarası formatını kontrol et
const validatePhoneNumber = (phone: string): boolean => {
    // Sadece rakam ve + işaretine izin ver
    const phoneRegex = /^\+[0-9]{1,4}[0-9]{6,14}$/;
    return phoneRegex.test(phone);
};

export const phoneAuthService = {
    // Recaptcha doğrulayıcısını başlat
    initRecaptcha: async (containerId: string): Promise<RecaptchaVerifier> => {
        try {
            // Eğer zaten bir recaptcha varsa temizle
            if (window.recaptchaVerifier) {
                window.recaptchaVerifier.clear();
            }

            // Container elementini kontrol et
            const container = document.getElementById(containerId);
            if (!container) {
                throw new Error('reCAPTCHA container bulunamadı');
            }

            // Yeni recaptcha oluştur
            const recaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
                'size': 'normal',
                'callback': () => {
                    console.log('reCAPTCHA doğrulandı');
                },
                'expired-callback': () => {
                    console.log('reCAPTCHA süresi doldu');
                    // Süre dolduğunda recaptcha'yı yenile
                    if (window.recaptchaVerifier) {
                        window.recaptchaVerifier.clear();
                        window.recaptchaVerifier.render();
                    }
                },
                'error-callback': () => {
                    console.log('reCAPTCHA hatası');
                    throw new Error('reCAPTCHA yüklenemedi. Lütfen sayfayı yenileyin.');
                }
            });

            // Recaptcha'yı render et
            await recaptchaVerifier.render();
            
            // Global değişkene ata
            window.recaptchaVerifier = recaptchaVerifier;
            
            return recaptchaVerifier;
        } catch (error: any) {
            console.error('reCAPTCHA başlatma hatası:', error);
            throw new Error('reCAPTCHA başlatılamadı: ' + error.message);
        }
    },

    // Telefon numarasına doğrulama kodu gönder
    sendVerificationCode: async (phone: string): Promise<string> => {
        try {
            // Telefon numarası formatını kontrol et
            if (!validatePhoneNumber(phone)) {
                throw new Error('Geçersiz telefon numarası formatı. Örnek format: +905551234567');
            }

            // Recaptcha kontrolü
            if (!window.recaptchaVerifier) {
                throw new Error('reCAPTCHA doğrulaması gerekli. Lütfen sayfayı yenileyin.');
            }

            const provider = new PhoneAuthProvider(auth);
            const verificationId = await provider.verifyPhoneNumber(phone, window.recaptchaVerifier);
            return verificationId;
        } catch (error: any) {
            console.error('SMS gönderme hatası:', error);
            // Hata mesajını daha anlaşılır hale getir
            if (error.code === 'auth/invalid-phone-number') {
                throw new Error('Geçersiz telefon numarası formatı. Örnek format: +905551234567');
            } else if (error.code === 'auth/too-many-requests') {
                throw new Error('Çok fazla deneme yaptınız. Lütfen daha sonra tekrar deneyin.');
            } else if (error.code === 'auth/network-request-failed') {
                throw new Error('İnternet bağlantınızı kontrol edin ve tekrar deneyin.');
            } else if (error.code === 'auth/invalid-app-credential') {
                throw new Error('reCAPTCHA doğrulaması başarısız oldu. Lütfen sayfayı yenileyip tekrar deneyin.');
            } else {
                throw new Error('Telefon doğrulama kodu gönderilemedi: ' + error.message);
            }
        }
    },

    // Doğrulama kodunu kontrol et
    verifyCode: async (verificationId: string, code: string): Promise<boolean> => {
        try {
            if (!code || code.length !== 6) {
                throw new Error('Doğrulama kodu 6 haneli olmalıdır');
            }

            const credential = PhoneAuthProvider.credential(verificationId, code);
            await signInWithCredential(auth, credential);
            return true;
        } catch (error: any) {
            console.error('Kod doğrulama hatası:', error);
            if (error.code === 'auth/invalid-verification-code') {
                throw new Error('Geçersiz doğrulama kodu');
            } else if (error.code === 'auth/code-expired') {
                throw new Error('Doğrulama kodunun süresi doldu. Lütfen yeni kod isteyin.');
            } else {
                throw new Error('Doğrulama kodu kontrol edilemedi: ' + error.message);
            }
        }
    },

    // Recaptcha'yı temizle
    clearRecaptcha: () => {
        try {
            if (window.recaptchaVerifier) {
                window.recaptchaVerifier.clear();
                window.recaptchaVerifier = null;
                console.log('reCAPTCHA instance cleared and nullified');
            }
            // Remove any existing reCAPTCHA elements
            const recaptchaElements = document.querySelectorAll('.grecaptcha-badge');
            recaptchaElements.forEach(element => {
                element.remove();
            });
            console.log('reCAPTCHA elements removed from DOM');
        } catch (error) {
            console.error('Error clearing reCAPTCHA:', error);
        }
    }
}; 